// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Vector2, IVector2 } from "./System.Numerics.Vector2.gen";
import { DetectionZoneCardinalDirection } from "./Shared.DetectionZoneCardinalDirection.gen";
import { DetectionZoneType } from "./DetectionZoneType.gen";

export interface IDetectionZone {
	points: IVector2[] | undefined;

	zoneCardinalDirection: DetectionZoneCardinalDirection | undefined;

	id: string | undefined;

	name: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	zoneType: DetectionZoneType;

	zoneIndex: number | undefined;

	zoneCardinalDirectionDegrees: number | undefined;

	vehicleCount: number;

	$type?: string | undefined;
}
export class DetectionZone {
	constructor(data?: IDetectionZone) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.points = data.points ? data.points.map((p: any) => new Vector2(p)) : [];
	}

	points: Vector2[] | undefined = [];

	zoneCardinalDirection: DetectionZoneCardinalDirection | undefined;

	id: string | undefined;

	name: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	zoneType: DetectionZoneType = 0;

	zoneIndex: number | undefined;

	zoneCardinalDirectionDegrees: number | undefined;

	vehicleCount: number = 0;

	static $type: string = "CoreApi.Models.DetectionZone, ";
	$type?: string | undefined = DetectionZone.$type;
}

